import React, { memo, PureComponent } from 'react';
import { bool } from 'prop-types';
import { connect } from 'react-redux';
import { UTCard, UTLabel, UTLoading } from '@widergy/energy-ui';

import { actionCreators as CustomProceduresActions } from 'redux/customProceduresHandlers';
import { message } from 'utils/stringUtils';

import Login from './layout';
import styles from './styles.module.scss';

class LoginContainer extends PureComponent {
  handleSubmit = values => this.props.dispatch(CustomProceduresActions.entitiesLogin(values));

  render() {
    return (
      <UTCard>
        <UTLabel className={styles.title} large>
          {message('EntitiesComplaint:loginTitle')}
        </UTLabel>
        <UTLoading preventUnmount loading={this.props.loading}>
          <Login onSubmit={this.handleSubmit} />
        </UTLoading>
      </UTCard>
    );
  }
}

LoginContainer.propTypes = {
  loading: bool
};

const mapStateToProps = store => ({
  loading: store.customProcedures.entitiesLoginLoading
});

export default connect(mapStateToProps)(memo(LoginContainer));
